export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_MOBILE_NAV = 'TOGGLE_MOBILE_NAV';